<template>
    <div>
        <error-component
                v-if="exceptions.length > 0"
                v-bind="exceptions[0]">
        </error-component>
        <div v-if="status !== 'loading'">
            <div v-if="status === 'forbidden'">
                <span>You can't get access to this report because you are not member of the organization</span>
            </div>
            <div v-else-if="status === 'private' && !this.$auth.check()">
                <span>This is a private visualization, you must </span>
                <router-link :to="{ name: 'login', query: { visualization_id: this.visualization_id} }">
                    <a>Log in</a>
                </router-link>
            </div>
            <div v-else>
                <div class="col-md-10 col-sm-10 mx-auto mt-3">
                    <section>
                        <h4>{{ title }}</h4>
                        <p v-if="chartData.chartType !== 'bigNumber'">{{ description }}</p>
                    </section>
                    <div v-if="parameters.length > 0">
                        <parameters-component></parameters-component>
                        <b-button class="btn btn-success" @click="reload()"
                                  v-b-tooltip.hover
                                  title="Get fresh data">
                            <font-awesome-icon icon="sync-alt" />
                            Reload
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div :style="{visibility: status === 'loading' ? 'hidden': 'visible'}">
            <chart-component :id="visualization_id" ref="chartCom" :data="data" :show="true"></chart-component>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {createHelpers} from 'vuex-map-fields';
    import ErrorComponent from '../../components/ErrorView.vue';
    import ChartComponent from '../../components/Chart.vue';
    import ParametersComponent from '../reports/Parameters.vue';

    const {mapFields} = createHelpers({
        getterType: 'visualizations/getField',
        mutationType: 'visualizations/updateField',
    });

    export default {
        props: ['visualization_id'],
        components: {
            ErrorComponent,
            ChartComponent,
            ParametersComponent,
        },
        data() {
            return {
                status: 'loading',
                data: {
                    idVisualization: this.visualization_id,
                    height: 400,
                    width: 400,
                }
            }
        },
        computed: {
            ...mapState({
                exceptions: 'exceptions',
            }),
            ...mapState('visualizations', {
                chartData: 'chartData'
            }),
            ...mapState('reports', {
                parameters: 'parameters'
            }),
            ...mapFields([
                'chartData.description',
                'chartData.title',
            ]),
        },
        created() {
            this.$store.dispatch('visualizations/getStatus', this.visualization_id).then((res) => {
                this.status = res.data.data.status;

                if (this.visualization_id) {
                    this.graph();
                }
            });
        },
        methods: {
            graph() {
                this.$refs.chartCom.graph();
            },
            reload() {
                this.$store.commit('reports/SET_PARAMETERS');
            },
        },
        beforeDestroy() {
            this.$store.commit('visualizations/SET_VISUALIZATION_PARAMETERS', []);
            this.$store.commit('visualizations/SET_PARAMETERS');
            this.$store.commit('CLEAR_EXCEPTIONS');
        },
    }
</script>